import React from 'react';
import Modal from 'shared/components/modal';
import Image1 from 'shared/img/checklist-welcome-image.svg';
import {EducationPhase} from '../../types/enums';
import browserHistory from 'shared/history';

type SvgComponent = React.FC<React.SVGProps<SVGSVGElement>>;

interface ModalContent {
  title: string;
  text: React.ReactNode;
  ModalImage: SvgComponent;
}

interface ChecklistModalProps {
  educationPhase: EducationPhase;
  handleClose?: () => void;
}

function ChecklistModal({educationPhase, handleClose}: ChecklistModalProps): React.ReactElement {
  const modalContent = {} as ModalContent;

  const closeModal = () => {
    if (handleClose) {
      handleClose();
    } else {
      browserHistory.push(window.location.pathname.split('/checklist-welcome')[0]);
    }
  };

  modalContent.ModalImage = Image1;

  modalContent.title = 'Welcome to your College Checklist';

  modalContent.text = (
    <>
      <p>
        {educationPhase === EducationPhase.HIGH_SCHOOL
          ? 'A checklist that allows you to track your college readiness journey throughout high school.'
          : 'A tailored checklist for college transfer and community college students, designed to track your ' +
            'college readiness journey throughout your academic experience.'}
      </p>
      <p>
        Discover opportunities to earn micro-scholarships on your College Checklist. This list
        highlights actions that not only ready you for college but also can earn you scholarship
        dollars for your educational journey along the way.
      </p>
    </>
  );

  return (
    <Modal show className="welcome-modal" onClose={handleClose}>
      <Modal.ImageHeader
        onClose={closeModal}
        backgroundImage={modalContent.ModalImage}
        backgroundColor="b200"
        color="white"
        height="tall"
      >
        {modalContent.title}
      </Modal.ImageHeader>
      <Modal.Body>{modalContent.text}</Modal.Body>
      <Modal.Footer
        primaryButton={{
          onClick: () => closeModal(),
          width: 85,
          text: 'Done',
        }}
      />
    </Modal>
  );
}

export default ChecklistModal;
